import { useEffect } from "react";
import useQueryState from "./useQueryState";
import { useParams, useLocation } from "react-router-dom";
import { useModal } from "core";

export const useAutoOpenModal = () => {
    const modal = useModal();
    const location = useLocation();
    const [{
        openModal,
        selectedProjectId,
        competitionId,
        singleProjectSelection,
        legalContestProjectThenForm,
        resumeLegalContestAfterForm,
    }, setQueryParams] = useQueryState();
    const { id } = useParams<{ id: string }>();

    useEffect(() => {
        if (!openModal) {
            return;
        }
        const modalId = (openModal === 'send-project' && competitionId) ? competitionId : id;
        modal.show(openModal, {
            id: modalId,
            selectedProjectId: selectedProjectId || undefined,
            singleProjectSelection:
              singleProjectSelection === '1' || singleProjectSelection === 'true',
            legalContestProjectThenForm:
              legalContestProjectThenForm === '1' || legalContestProjectThenForm === 'true',
            resumeLegalContestDeferredApply:
              resumeLegalContestAfterForm === '1' || resumeLegalContestAfterForm === 'true',
            onClose: () => modal.hide(),
        });
        setQueryParams({
            openModal: undefined,
            selectedProjectId: undefined,
            competitionId: undefined,
            singleProjectSelection: undefined,
            legalContestProjectThenForm: undefined,
            resumeLegalContestAfterForm: undefined,
        }, { replace: true });
    }, [
        location.search,
        openModal,
        selectedProjectId,
        competitionId,
        singleProjectSelection,
        legalContestProjectThenForm,
        resumeLegalContestAfterForm,
        id,
        modal,
        setQueryParams,
    ]);

    return []
}import { useEffect } from "react";
import useQueryState from "./useQueryState";
import { useParams, useLocation } from "react-router-dom";
import { useModal } from "core";

export const useAutoOpenModal = () => {
    const modal = useModal();
    const location = useLocation();
    const [{
        openModal,
        selectedProjectId,
        competitionId,
        singleProjectSelection,
        legalContestProjectThenForm,
        resumeLegalContestAfterForm,
    }, setQueryParams] = useQueryState();
    const { id } = useParams<{ id: string }>();

    useEffect(() => {
        if (!openModal) {
            return;
        }
        const modalId = (openModal === 'send-project' && competitionId) ? competitionId : id;
        modal.show(openModal, {
            id: modalId,
            selectedProjectId: selectedProjectId || undefined,
            singleProjectSelection:
              singleProjectSelection === '1' || singleProjectSelection === 'true',
            legalContestProjectThenForm:
              legalContestProjectThenForm === '1' || legalContestProjectThenForm === 'true',
            resumeLegalContestDeferredApply:
              resumeLegalContestAfterForm === '1' || resumeLegalContestAfterForm === 'true',
            onClose: () => modal.hide(),
        });
        setQueryParams({
            openModal: undefined,
            selectedProjectId: undefined,
            competitionId: undefined,
            singleProjectSelection: undefined,
            legalContestProjectThenForm: undefined,
            resumeLegalContestAfterForm: undefined,
        }, { replace: true });
    }, [
        location.search,
        openModal,
        selectedProjectId,
        competitionId,
        singleProjectSelection,
        legalContestProjectThenForm,
        resumeLegalContestAfterForm,
        id,
        modal,
        setQueryParams,
    ]);

    return []
}